var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FFEAEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2618 7.47528C15.2618 9.27627 13.8015 10.7377 12.0006 10.7377C10.1984 10.7377 8.73816 9.27741 8.73816 7.47528C8.73816 5.67316 10.1984 4.21289 12.0006 4.21289C13.8015 4.21289 15.2618 5.67316 15.2618 7.47528ZM7.76238 11.5527C5.9614 11.5527 4.5 13.013 4.5 14.814C4.5 16.6149 5.96026 18.0764 7.76238 18.0764C9.56451 18.0764 11.0248 16.6161 11.0248 14.814C11.0248 13.013 9.56451 11.5527 7.76238 11.5527ZM16.2376 11.5527C14.4354 11.5527 12.9752 13.013 12.9752 14.8151C12.9752 16.6172 14.4354 18.0774 16.2376 18.0774C18.0386 18.0774 19.5 16.6172 19.5 14.8151C19.5 13.013 18.0397 11.5527 16.2376 11.5527Z",
    fill: "#FF584A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsana);
export default __webpack_public_path__ + "static/media/Asana.c7c120b4cdc83fc1517878960fe9464f.svg";
export { ForwardRef as ReactComponent };